import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Tabs,
  Tooltip,
  DatePicker,
  Checkbox
} from "antd";
import { Header } from "../../../../components";
import { useStateContext } from "../../../../contexts/ContextProvider";
import {
  UseFetchCases,
  UseFetchManageCase,
  UseFetchStartCase,
  UseFetchAssignCase,
} from "../hooks/useFetch";
import {
  UseFetchCreatePanelInput
} from "../../Input/hooks/useFetch"
import Table from "../components/Table";
import CaseForm from "../components/CaseForm";
import AddForm from "../components/AddForm"
import DetailsModal from "../components/DetailsModal";
import CaseSummary from "../components/CaseSummary";
import TableAllCaseHistory from "../../Input/components/Table";
import { UseFetchCaseSetting } from "../../../../modules/admin/AddCaseSetting/hooks/useFetch";
import { useFetchListInput } from "../../Input/hooks/useFetch";
import { useNewWorkSound } from "../../../../hooks/useNewWorkSound";
import { useHoldTooLongAlert } from "../../../../hooks/useHoldTooLongAlert";
import dayjs from "dayjs";
import { INPUT_CASE_TYPE_OPTIONS } from "../../../../data/constant";
const { RangePicker } = DatePicker;

const caseTypeFilterOptions = INPUT_CASE_TYPE_OPTIONS.map((opt) => (
  <Select.Option key={opt.value} value={opt.value}>
    {opt.label}
  </Select.Option>
));

function CasePage() {
  //#region Constructor
  const { activeMenu, screenSize } = useStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [editingRecord, setEditingRecord] = useState(null);
  const [viewingRecord, setViewingRecord] = useState(null);
  const [isLastTab, setIsLastTab] = useState(false);
  // userId (ลูกค้า) ที่เพิ่งกรอกใน CaseForm ให้เคสที่ส่งมาแบบ "ไม่มี User"
  // เก็บที่นี่เพราะ editingRecord เป็น snapshot ที่ refetch() ไม่อัปเดต — ถ้าอ่าน editingRecord.userId
  // ตรง ๆ ด่านกันปิดเคสจะบล็อกผิดทั้งที่กรอกไปแล้ว
  const [savedUserId, setSavedUserId] = useState(null);
  // กันกดยืนยันซ้ำ: มี async gap (validateFields) ก่อนเปิด Modal.confirm
  // กดรัว ๆ ตอนนั้นทำให้ confirm ซ้อน → ยิง manageCase ซ้ำ → เคสเดียวถูก finish หลายครั้ง (ที่มาของ lock ค้าง)
  const isSubmittingRef = useRef(false);
  const { mutateAsync: manageCase, isLoading: isCreatingCase } = UseFetchManageCase();
  const { mutate: createPanelInput } = UseFetchCreatePanelInput()
  const { mutateAsync: startCase } = UseFetchStartCase();
  const { mutateAsync: assignCase } = UseFetchAssignCase();
  const userId = sessionStorage.getItem("id");
  const { data: cases = [], isLoading, refetch } = UseFetchCases(userId);
  const companyId = sessionStorage.getItem("activeCompanyId");
  const { data: caseSetting } = UseFetchCaseSetting(companyId);
  const [listInputData, setListInputData] = useState([]);
  const { mutateAsync: fetchListInput, isLoading: isLoadingListInput } = useFetchListInput();

  // Search states for both tabs
  const [myCasesSearchText, setMyCasesSearchText] = useState("");
  const [myCasesStatusFilter, setMyCasesStatusFilter] = useState();
  const [allCasesSearchText, setAllCasesSearchText] = useState("");
  const [allCasesStatusFilter, setAllCasesStatusFilter] = useState();
  const [allCasesCaseNameFilter, setAllCasesCaseNameFilter] = useState();
  const [myCasesCaseNameFilter, setMyCasesCaseNameFilter] = useState();

  const [historyDateFilter, setHistoryDateFilter] = useState([dayjs(), dayjs()]);
  const [historySearchText, setHistorySearchText] = useState("");
  const [historyStatusFilter, setHistoryStatusFilter] = useState();
  const [historyCaseNameFilter, setHistoryCaseNameFilter] = useState();
  //#endregion

  const [checkBoxChecked, setCheckBoxChecked] = useState(true);
    const label = `${checkBoxChecked ? 'งานของฉัน' : 'งานทั้งหมด'}`;
  
    const onCheckboxChange = (e) => {
      setCheckBoxChecked(e.target.checked);
    };
  
    // แผง History ตั้งใจไม่ subscribe 'case:updated'
    // event ถูก broadcast ทั้งบริษัท → ทุกเครื่องโหลดรายการทั้งวันใหม่พร้อมกัน
    // (วัดจาก prod: POST /input/list 30,636 ครั้ง/105 นาที = 78% ของโหลดทั้งระบบ)
    // หน้านี้เป็น "ประวัติ" ไม่ใช่คิวงาน — คิวงาน (งานของฉัน/งานทั้งหมด) ใช้
    // UseFetchCases คนละเส้น และยัง realtime เต็มที่เหมือนเดิม
    // อยากได้สดทันที: กดปุ่ม Filter
    useEffect(() => {
      let intervalId;

      handleSearch(); // โหลดครั้งแรก

      if (checkBoxChecked) {
        intervalId = setInterval(handleSearch, 30000);
      }

      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    }, [checkBoxChecked,historyDateFilter]);


  const myCases = cases.filter(
    (caseItem) =>
      caseItem.assign_to == userId &&
      (caseItem.status == "Waiting" || caseItem.status == "Processing")
  );

  // ติ๊งเมื่องานของฉันเพิ่มขึ้น — ใช้ myCases (ยังไม่ผ่านช่องค้นหา)
  // ถ้าใช้ filterMyCasesData() พอผู้ใช้ลบข้อความในช่อง Filter ตัวเลขจะเด้งขึ้นแล้วติ๊งมั่ว
  useNewWorkSound(isLoading ? null : myCases.length);

  // เตือนซ้ำเมื่อถือเคสไว้นานเกินโดยยังไม่กด Start
  // เฉพาะ Waiting เท่านั้น — ที่กด Start แล้ว (Processing) คือกำลังทำอยู่จริง
  // จากข้อมูล 7 วัน 15% ของเคสใช้เวลาทำเกิน 2 นาทีตามปกติ ไม่ควรไปเร่ง
  const myWaitingCases = myCases.filter((c) => c.status == "Waiting");
  useHoldTooLongAlert(myWaitingCases);
  const allCases = cases.filter(
    (caseItem) =>
      (caseItem.status == "Waiting" || caseItem.status == "Pending") &&
      caseItem.assign_to == null
  );

  // useEffect(() => {
  //   handleSearch();
  // }, []);

  // นับจำนวน cases แยกตาม status สำหรับ tab งานทั้งหมด
  const pendingCases = allCases.filter(
    (caseItem) => caseItem.status === "Pending"
  );
  const waitingCases = allCases.filter(
    (caseItem) => caseItem.status === "Waiting"
  );

  const formAddRef = useRef(null);

  // Filter functions for search
  const filterMyCasesData = () => {
    let filteredData = myCases;

    // Filter by search text
    if (myCasesSearchText) {
      const searchLower = myCasesSearchText.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return (
          (item.userId &&
            item.userId.toString().toLowerCase().includes(searchLower)) ||
          (item.caseName &&
            item.caseName.toLowerCase().includes(searchLower)) ||
          (item.description &&
            item.description.toLowerCase().includes(searchLower)) ||
          (item.status && item.status.toLowerCase().includes(searchLower)) ||
          (item.priority && item.priority.toLowerCase().includes(searchLower))
        );
      });
    }

    // Filter by status
    if (myCasesStatusFilter) {
      filteredData = filteredData.filter(
        (item) => item.status === myCasesStatusFilter
      );
    }

    if (myCasesCaseNameFilter) {
      filteredData = filteredData.filter(
        (item) => item.caseName === myCasesCaseNameFilter
      );
    }

    return filteredData;
  };

  const filterAllCasesData = () => {
    let filteredData = allCases;

    // Filter by search text
    if (allCasesSearchText) {
      const searchLower = allCasesSearchText.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return (
          (item.userId &&
            item.userId.toString().toLowerCase().includes(searchLower)) ||
          (item.caseName &&
            item.caseName.toLowerCase().includes(searchLower)) ||
          (item.description &&
            item.description.toLowerCase().includes(searchLower)) ||
          (item.status && item.status.toLowerCase().includes(searchLower)) ||
          (item.priority && item.priority.toLowerCase().includes(searchLower))
        );
      });
    }

    // Filter by status
    if (allCasesStatusFilter) {
      filteredData = filteredData.filter(
        (item) => item.status === allCasesStatusFilter
      );
    }

    if (allCasesCaseNameFilter) {
      filteredData = filteredData.filter(
        (item) => item.caseName === allCasesCaseNameFilter
      );
    }

    return filteredData;
  };

  //#region Modal Manage case
  const handleModalOk = async () => {
    // กันกดซ้ำระหว่างกำลังทำรายการ (จนกว่า confirm จะปิด)
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    try {
      // เคสที่ส่งมาแบบ "ไม่มี User" ต้องกรอก UserId ก่อนถึงจะปิดเคสได้
      // (backend กันอีกชั้นด้วยการอ่านค่าสดจาก DB — ตรงนี้แค่เตือนแต่เนิ่น ๆ ไม่ให้กรอกฟอร์มจนจบแล้วโดนเด้ง)
      const customerUserId = savedUserId ?? editingRecord?.userId;
      if (editingRecord && !customerUserId) {
        message.error("เคสนี้ยังไม่มี User — กรุณากรอก UserId ก่อนปิดเคส");
        isSubmittingRef.current = false;
        return;
      }

      const values = await form.validateFields();
      // แปลง customFields จาก number key เป็น array ที่มี number, title, value
      let customFieldsArray = [];
      if (values.customFields && caseSetting && values.case3) {
        // หา case3 จาก caseSetting
        let foundCase3 = null;
        for (const case1 of caseSetting) {
          if (case1.subcases) {
            foundCase3 = case1.subcases.find(sub => sub.id == values.case3);
            if (foundCase3) break;
          }
        }

        if (foundCase3 && foundCase3.customfield_subcase) {
          // สร้าง Map จาก number ไป title
          const numberToTitleMap = new Map();
          foundCase3.customfield_subcase
            .sort((a, b) => a.number - b.number)
            .forEach(field => {
              numberToTitleMap.set(field.number.toString(), field.customfield_name);
            });

          // แปลง customFields เป็น array ที่เรียงตาม number
          customFieldsArray = Object.entries(values.customFields || {})
            .map(([numberKey, value]) => {
              const number = parseInt(numberKey);
              const title = numberToTitleMap.get(numberKey);
              if (title && (value !== undefined && value !== null && value !== '')) {
                return {
                  number: number,
                  title: title,
                  value: value
                };
              }
              return null;
            })
            .filter(item => item !== null)
            .sort((a, b) => a.number - b.number);
        }
      }
      const payload = {
        ...values,
        customFields: customFieldsArray, // ส่งเป็น array ที่มี number, title, value
        userId: userId,
        id: editingRecord?.id,
        dateDeposit: values.dateDeposit && typeof values.dateDeposit.format === "function" ? values.dateDeposit.format("YYYY-MM-DD") : values.dateDeposit,
        timeDeposit: values.timeDeposit && typeof values.timeDeposit.format === "function" ? values.timeDeposit.format("HH.mm") : values.timeDeposit,
      };

      Modal.confirm({
        title: 'ยืนยันการทำรายการ',
        width: 800,
        content: <CaseSummary data={payload} />,
        okText: 'ยืนยัน',
        cancelText: 'ยกเลิก',
        // ปลดล็อกเมื่อ confirm ปิดสนิท (ทั้งยืนยัน/ยกเลิก) → พร้อมกดรอบใหม่ได้
        afterClose: () => { isSubmittingRef.current = false; },
        onOk: async () => {
          // mutateAsync + await → Modal.confirm รอจน manageCase เสร็จจริง (ปุ่ม OK จะ loading เอง)
          // throw ต่อถ้า error เพื่อให้ dialog ไม่ปิด + ไม่ขึ้น success ลวง
          try {
            await manageCase(payload);
          } catch (err) {
            message.error(err?.response?.data?.message || "Failed to manage case");
            throw err;
          }
          message.success("Manage case successfully");
          setIsModalOpen(false);
          form.resetFields();
          setEditingRecord(null);
          setSavedUserId(null);
          refetch();
        }
      });
    } catch (error) {
      // validateFields ล้มเหลว → Modal.confirm ไม่ถูกเปิด (afterClose ไม่ยิง) ต้องปลดล็อกที่นี่
      isSubmittingRef.current = false;
      console.log(error);
      if (error?.errorFields?.length > 0) {
        message.error("กรุณากรอกข้อมูลให้ครบ");
      } else {
        message.error("Failed to manage case");
      }
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setEditingRecord(null);
    setSavedUserId(null);
    // Refresh ข้อมูลหลังจากปิด modal
    setTimeout(() => {
      refetch();
    }, 2000);
  };
  //#endregion

  const handleDelete = (record) => {
    // TODO: Implement delete functionality
    console.log("Delete case:", record);
  };

  const handleEdit = async (record) => {
    if (record.status == "Waiting") {
      try {
        await startCase({ id: record.id }); // mutateAsync: รอจน start เสร็จจริง
        refetch(); // เสร็จแล้ว refetch ทันที (ไม่ต้องหน่วง setTimeout)
      } catch (error) {
        message.error("ไม่สามารถเริ่มงานได้");
        return; // ไม่เปิด modal ถ้า start case ไม่สำเร็จ
      }
    }
    setEditingRecord(record);
    setSavedUserId(null); // เปิดเคสใหม่ → ลืม userId ที่กรอกให้เคสก่อนหน้า
    setIsModalOpen(true);
    form.setFieldsValue(record);
  };

  const handleAdd = () => {
    setEditingRecord(null);
    setSavedUserId(null);
    setIsModalOpen(true);
    form.resetFields();
  };

  const handleViewDetails = (record) => {
    setViewingRecord(record);
    setIsDetailsModalOpen(true);
  };

  const handleAssign = async (record) => {
    try {
      await assignCase({
        id: record.id,
        assign_to: userId,
      });

      message.success("Assign case successfully");
      refetch();
    } catch (error) {
      message.error("Failed to assign case");
    }
  };


  const handleDetailsModalCancel = () => {
    setIsDetailsModalOpen(false);
    setViewingRecord(null);
  };

  const handleTabChange = (isLast) => {
    setIsLastTab(isLast);
  };

  //#region Modal add Panel
  const handleAddModalOk = async (formData) => {
    try {
      // Format images - remove data URL prefix
      const formattedImages = formData.images?.map((image) =>
        image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
      ) || [];

      const formattedImagesChoice = formData.imagesChoice?.map((image) =>
        image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
      ) || [];

      const payload = {
        caseName: formData.case,
        userId: formData.user,
        note: formData.note,
        img: formattedImages,
        imgChoice: formattedImagesChoice,
        createBy: userId,
        companyId: sessionStorage.getItem("activeCompanyId"),
      };
      // เรียก API เพื่อสร้าง case ใหม่
      await createPanelInput(payload);
      message.success("เพิ่ม Case สำเร็จ");
      setIsAddModalOpen(false);
      // รีเฟรชข้อมูลหลังจากเพิ่มสำเร็จ
      setTimeout(() => {
        refetch();
      }, 2000);
      formAddRef.current?.resetFields();
    } catch (error) {
      console.error("Error adding case:", error);
      message.error("ไม่สามารถเพิ่ม Case ได้");
    }
  };

  const handleAddModalCancel = () => {
    setIsAddModalOpen(false);
    formAddRef.current?.resetFields();
  };

  const showAddModal = () => {
    setIsAddModalOpen(true);
  };
  //#endregion

  const handleSearch = async () => {
    let startDate = historyDateFilter[0].format('YYYY-MM-DD');
    let endDate = historyDateFilter[1].format('YYYY-MM-DD');
    let filter = {}
    if (checkBoxChecked == true) {
      filter = {
        checkBoxcaseType: true,
        startDate,
        endDate,
        //limit: 50
      };
    } else {
      filter = {
        startDate,
        endDate,
        status: historyStatusFilter,
        caseName: historyCaseNameFilter,
        search: historySearchText,
        checkBoxcaseType: false,
        limit: 100
      };
    }
    const result = await fetchListInput(filter); 
    if (result?.result && result?.result.length > 0) {
      setListInputData(result?.result);
    } else setListInputData([]);
  };

  const items = [
    {
      key: "1",
      label: (
        <span>
          งานของฉัน{" "}
          <span className= {filterMyCasesData().length > 0 ? "bg-red-500 text-white rounded-full px-2 py-1 text-xs font-medium ml-1" : "bg-gray-200 text-black rounded-full px-2 py-1 text-xs font-medium ml-1"}>
            {filterMyCasesData().length}
          </span>
        </span>
      ),
      children: (
        <div>
          <div className="mb-4 flex gap-3">
            <Input
              placeholder="Filter"
              value={myCasesSearchText}
              onChange={(e) => setMyCasesSearchText(e.target.value)}
              allowClear
              className="w-80"
            />
            <Select
              placeholder="Status"
              value={myCasesStatusFilter}
              onChange={setMyCasesStatusFilter}
              allowClear
              className="w-32"
            >
              <Select.Option value="Success">Success</Select.Option>
              <Select.Option value="Reject">Reject</Select.Option>
              <Select.Option value="Inform">Inform</Select.Option>
              <Select.Option value="Waiting">Waiting</Select.Option>
              <Select.Option value="Pending">Pending</Select.Option>
            </Select>
            <Select
              placeholder="Case Type"
              value={myCasesCaseNameFilter}
              onChange={setMyCasesCaseNameFilter}
              allowClear
              className="w-36"
            >
              {caseTypeFilterOptions}
            </Select>
            <div style={{ marginLeft: "auto" }}>
              <Button
                onClick={showAddModal}
                className="bg-blue-500 text-white"
              >
                เพิ่ม
              </Button>
            </div>
          </div>


          <Table
            data={filterMyCasesData()}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={isLoading}
            bordered
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <span>
          งานทั้งหมด{" "}
          <Tooltip title="Waiting">
            <span className="bg-blue-500 text-white rounded-full px-2 py-1 text-xs font-medium ml-1">
              {waitingCases.length}
            </span>
          </Tooltip>
          <Tooltip title="Pending">
            <span className="bg-orange-500 text-white rounded-full px-2 py-1 text-xs font-medium ml-1">
              {pendingCases.length}
            </span>
          </Tooltip>
        </span>
      ),
      children: (
        <div>
          <div className="mb-4 flex gap-3">
            <Input
              placeholder="Filter"
              value={allCasesSearchText}
              onChange={(e) => setAllCasesSearchText(e.target.value)}
              allowClear
              className="w-80"
            />
            <Select
              placeholder="Status"
              value={allCasesStatusFilter}
              onChange={setAllCasesStatusFilter}
              allowClear
              className="w-32"
            >
              <Select.Option value="Success">Success</Select.Option>
              <Select.Option value="Reject">Reject</Select.Option>
              <Select.Option value="Inform">Inform</Select.Option>
              <Select.Option value="Waiting">Waiting</Select.Option>
              <Select.Option value="Pending">Pending</Select.Option>
            </Select>
            <Select
              placeholder="Case Type"
              value={allCasesCaseNameFilter}
              onChange={setAllCasesCaseNameFilter}
              allowClear
              className="w-36"
            >
              {caseTypeFilterOptions}
            </Select>
            <div style={{ marginLeft: "auto" }}>
              <Button
                onClick={showAddModal}
                className="bg-blue-500 text-white"
              >
                เพิ่ม
              </Button>
            </div>
          </div>
          <Table
            data={filterAllCasesData()}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onAssign={handleAssign}
            onViewDetails={handleViewDetails}
            loading={isLoading}
            bordered
            isAllCases={true}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="md:m-10">
      <div className="flex justify-between mb-6">
        <Header category="App" title="จัดการเคส" />
      </div>

      <Tabs defaultActiveKey="1" items={items} style={{ marginBottom: "20px" }} />

      <Modal
        title={"จัดการงาน"}
        open={isModalOpen}
        onOk={isLastTab ? handleModalOk : undefined}
        onCancel={handleModalCancel}
        // กรอกฟอร์มยาวอยู่ เผลอคลิกพื้นที่ว่าง/กด Esc แล้วหายหมด → ปิดได้จากปุ่มกากบาท/ปุ่ม "ปิด" เท่านั้น
        maskClosable={false}
        keyboard={false}
        width={activeMenu && (screenSize > 900 || screenSize === undefined) ? "calc(100% - 240px)" : "100%"}
        style={{
          maxWidth: '100%',
          paddingBottom: 0,
          zIndex: 10000001,
          marginLeft: activeMenu && (screenSize > 900 || screenSize === undefined) ? '240px' : '0px',
          top: 20,
          height: '100vh'
        }}
        // maskStyle={{
        //   marginLeft: activeMenu && (screenSize > 900 || screenSize === undefined) ? '240px' : '0px',
        //   zIndex: 10000000
        // }}
        setIsModalOpen={setIsModalOpen}
        okButtonProps={isLastTab ? { loading: isCreatingCase, disabled: isCreatingCase } : { style: { display: "none" } }}
        cancelText="ปิด"
      >
        <CaseForm
          form={form}
          editingRecord={editingRecord}
          setIsModalOpen={setIsModalOpen}
          refetch={refetch}
          caseSetting={caseSetting}
          onTabChange={handleTabChange}
          savedUserId={savedUserId}
          setSavedUserId={setSavedUserId}
        />
      </Modal>

      <DetailsModal
        visible={isDetailsModalOpen}
        onClose={handleDetailsModalCancel}
        record={viewingRecord}
        onAssign={handleAssign}
      />

      <Modal
        title="เพิ่ม Case"
        open={isAddModalOpen}
        onCancel={handleAddModalCancel}
        width={600}
        footer={null}
        key={isAddModalOpen ? 'add-modal' : 'closed-modal'}
      >
        <AddForm
          key={isAddModalOpen ? 'add-form-open' : 'add-form-closed'}
          formRef={formAddRef}
          isLoading={isCreatingCase}
          onFinish={handleAddModalOk}
        />
      </Modal>

      <Header category="App" title="History" />
      <div className="mb-4 flex gap-3">
        <RangePicker
          placeholder="Date"
          value={historyDateFilter}
          onChange={(date) => setHistoryDateFilter(date)}
          allowClear
          className="w-64"
        />
        <Input
          placeholder="Filter"
          value={historySearchText}
          onChange={(e) => setHistorySearchText(e.target.value)}
          allowClear
          className="w-80"
        />
        <Select
          placeholder="Status"
          value={historyStatusFilter}
          onChange={setHistoryStatusFilter}
          allowClear
          className="w-32"
        >
          <Select.Option value="Success">Success</Select.Option>
          <Select.Option value="Reject">Reject</Select.Option>
              <Select.Option value="Inform">Inform</Select.Option>
          <Select.Option value="Waiting">Waiting</Select.Option>
          <Select.Option value="Pending">Pending</Select.Option>
        </Select>
        <Select
          placeholder="Case Type"
          value={historyCaseNameFilter}
          onChange={setHistoryCaseNameFilter}
          allowClear
          className="w-36"
        >
          {caseTypeFilterOptions}
        </Select>
        <Checkbox checked={checkBoxChecked} onChange={onCheckboxChange}>
          <p style={{ marginTop: 4 }}>{label}</p>
        </Checkbox>
        <Button type="primary" onClick={handleSearch}>Filter</Button>
      </div>
      <TableAllCaseHistory
        data={listInputData}
        onEdit={handleEdit}
        onDelete={handleDelete}
        //onRejectCancel={handleRejectCancel}
        loading={isLoadingListInput}
        isHistory={true}
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}

export default CasePage;
